input {
  border: none;
  outline: none;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  color: var(--lab-ds-semantic-color-fg-default);
}

.v4-input {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  color: var(--lab-ds-semantic-color-fg-default);
  max-width: 100%;
}

.v4-input .title-text {
  text-align: left;
  font: var(--lab-ds-semantic-typography-heading-h7);
}

.v4-input .input-helper {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-s);
}

.v4-input .helper-text {
  display: flex;
  align-items: center;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p3-regular);
}

.clean-visible {
  display: none;
}

.input-field {
  width: 100%;
}

.input-icon {
  display: flex;
  align-items: center;

  border-style: solid;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-xs);
  border-width: var(--lab-ds-semantic-selectable-border-width-m);
  border-color: var(--lab-ds-semantic-selectable-color-border-default);
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);

  padding-top: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-left: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-right: var(--lab-ds-semantic-selectable-space-padding-m);
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  margin-bottom: 0;
}

.input-icon .input-field {
  color: var(--lab-ds-semantic-color-fg-enabled);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p2-regular);
}

.input-icon .icon.right {
  cursor: pointer;
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}

.options {
  font: var(--lab-ds-semantic-typography-body-none-decoration-p2-regular);
  position: relative;
}

.hints {
  max-height: 21rem;
  overflow-y: auto;
  overflow-x: hidden;

  border-style: solid;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-xs);
  border-width: var(--lab-ds-semantic-selectable-border-width-m);

  padding-right: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-left: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-top: var(--lab-ds-semantic-selectable-space-padding-sm);
  gap: var(--lab-ds-semantic-selectable-space-gap-s);

  background-color: var(--lab-ds-semantic-selectable-color-bg-pure);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
  color: var(--lab-ds-semantic-color-fg-default);
}

.hint-container {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: var(--lab-ds-semantic-selectable-space-gap-s);

  cursor: pointer;
}

.input-icon:focus-within {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.input-icon:hover {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-s);
  border-color: var(--lab-ds-semantic-selectable-color-primary-hover);
}

.input-icon:active {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.v4-input.disabled .input-icon {
  background-color: var(--lab-ds-semantic-selectable-color-bg-disabled);
  border-color: var(--lab-ds-semantic-selectable-color-border-disabled);
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
  box-shadow: none;
}

.v4-input.disabled .title-text {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .input-field {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .icon {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .input-helper {
  color: var(--lab-ds-semantic-color-fg-disabled);
}
